// src/validationSchemas/discountSchema.js
import { z } from "zod";

export const discountSchema = z
  .object({
    // 1. Discount type (required)
    discountType: z
      .enum(["percentage", "fixed"])
      .refine((val) => !!val, { message: "Discount type is required" }),

    // 2. Discount value (required, must be positive)
    discountValue: z
      .number({ invalid_type_error: "Discount value must be a number" })
      .positive("Discount value must be greater than zero"),

    // 3. Discount code (optional)
    discountCode: z
      .string()
      .min(3, "Discount code must be at least 3 characters")
      .max(50, "Discount code must be under 50 characters")
      .optional(),

    // 4. Auto apply checkbox (boolean, optional)
    autoApplyDiscount: z.boolean().optional(),

    // 5. Start and end dates (optional for now but end must be after start if both exist)
    discountStartDate: z.string().optional(),
    discountEndDate: z.string().optional(),
  })
  .refine((data) => {
    if (data.discountStartDate && data.discountEndDate) {
      const start = new Date(data.discountStartDate);
      const end = new Date(data.discountEndDate);
      return end >= start;
    }
    return true;
  }, {
    message: "End date must be after start date",
    path: ["endDate"],
  });
